import { UPDATES_MSG, updatesLeadOf, type UpdateItem } from "@genbaryoku/contract";
import { useEffect } from "react";
import { Link } from "react-router";
import { usePageName } from "../components/BackButton.jsx";
import { useHelpIndex } from "../components/HelpPanel.jsx";
import { KindChip, publishedHelp, useUpdates } from "../components/Updates.jsx";
import { useProduct } from "../lib/useProduct.js";

/**
 * 更新情報（/updates、#204、docs/83 §5）：公開済みの更新を月ごとに（新しい順）。ログイン前でも読める・検索エンジンに出してよい。
 * 紹介ページとヘルプの目次からリンク。枠は法務のページと同じ（ロゴ → 紙の1枚）。誘導する記事が公開のヘルプにあれば「ヘルプで見る」
 */
export function UpdatesPage() {
  const P = useProduct();
  const q = useUpdates();
  const help = useHelpIndex();
  usePageName(UPDATES_MSG.title);
  useEffect(() => {
    document.title = `${UPDATES_MSG.title}｜${P.name}`;
  }, [P.name]);
  const months = new Map<string, UpdateItem[]>();
  for (const u of q.data?.items ?? []) {
    const d = new Date(new Date(u.publishedAt).getTime() + 9 * 3_600_000);
    const k = UPDATES_MSG.month(d.getUTCFullYear(), d.getUTCMonth() + 1);
    months.set(k, [...(months.get(k) ?? []), u]);
  }
  return (
    <main className="legal" data-product={P.product} data-testid="updates-page">
      <header className="legal-top">
        <Link to="/login" className="legal-logo" aria-label={P.name}>
          <img src={P.assets.logo} alt={P.name} width={324} height={100} />
        </Link>
      </header>
      <article className="legal-doc updates-doc">
        <h1>{UPDATES_MSG.title}</h1>
        <p className="uplead">{updatesLeadOf(P.name)}</p>
        {q.isPending ? null : q.isError ? (
          <p className="upempty" role="alert">
            {UPDATES_MSG.loadFailed}
          </p>
        ) : !q.data.items.length ? (
          <p className="upempty" data-testid="updates-empty">
            {UPDATES_MSG.empty}
          </p>
        ) : (
          [...months].map(([m, list]) => (
            <section key={m} data-testid="updates-month">
              <h2 className="upmonth">{m}</h2>
              {list.map((u) => (
                <div key={u.id} className="uprow" data-testid="updates-item" data-update={u.id}>
                  <p className="upmeta">
                    <KindChip kind={u.kind} />
                    <span>{UPDATES_MSG.date(u.publishedAt)}</span>
                  </p>
                  <h3>{u.title}</h3>
                  <p className="upbody">{u.body}</p>
                  {u.help && publishedHelp(help.data, u.help.id) ? (
                    <p>
                      <a href={u.help.url} data-testid="updates-help">
                        {UPDATES_MSG.openHelp}
                      </a>
                    </p>
                  ) : null}
                </div>
              ))}
            </section>
          ))
        )}
      </article>
    </main>
  );
}
